module.exports = __webpack_public_path__ + "static/evencorp-facc34be07632f56c7b7495a576c11b9.jpg";